import React, { useEffect, useState, useRef } from "react";
import { FormGroup, ControlLabel, FormControl, Table, Button, Row, Col, Modal, Grid } from "react-bootstrap";
import Select from "react-select";
import * as API from '../../../api/billing'
import BillingTable from './BillingTable'
import { debounce } from "lodash";
import axios from "axios";
import * as PF from "Front/views/Home/PublicFunction.jsx";
import { appConstants } from "Front/_constants/app.constants.js";
import Preview from "./Preview";
import ReactToPrint from 'react-to-print';
import Print from "./Print";



let cancel;

let lastSearchedText = ""


const Bill = ({ billCategoryList = [], showSearchBar, handleCloseModal, row, handleShowSuccessMsg }) => {
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [billNo, setBillNo] = useState("");
    const [billDate, setBillDate] = useState(new Date().toISOString().slice(0, 10));
    const [billType, setBillType] = useState("")
    const [billCategory, setBillCategory] = useState(null)
    const [billSubCategory, setBillSubCategory] = useState(null)
    const [billSubCategoryList, setBillSubCategoryList] = useState([])
    const [services, setServices] = useState([])
    const [totalAmount, setTotalAmount] = useState(0)
    const [totalPaidAmount, setTotalPaidAmount] = useState(0)
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0)
    const [totalRemainingAmount, setTotalRemainingAmount] = useState(0)
    const [paymentMode, setPaymentMode] = useState("cash")
    const [patients, setPatients] = useState([])
    const [showPreviewModal, setShowPreviewModal] = useState(false)
    const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
    const printRef = useRef();
    const [btnClicked, setBtnClicked] = useState(false)


    const handleBillCategory = (category) => {
        setBillCategory(category)
        setBillSubCategory({})
        getBillSubCategoryList(category)
    }

    const addServiceToBill = (billSubCategory) => {
        setBillSubCategory(billSubCategory)
        if (billSubCategory && billSubCategory.label) {
            const newItem = {
                id: Date.now(),
                serviceId: billSubCategory?.value,
                item: billSubCategory.label,
                price: billSubCategory.price,
                quantity: 1,
                discount: 0
            };
            setServices((prevServices) => [...prevServices, newItem])
        }
    };


    const getBillSubCategoryList = async (category) => {
        let resp = await API.servicesBasedOnCategory(category?.value);
        if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
            const billSubCategoryOptions = resp.data.data.map((ele) => {
                return {
                    label: ele?.name, value: ele?._id, ...ele
                }
            })
            setBillSubCategoryList(billSubCategoryOptions)
        }
    }

    const patientSearch = debounce(async (inputValue) => {
        if (cancel) {
            cancel(); // Cancel the previous API request
        }

        // setIsSpecialCharacter(false);

        let search = inputValue.trim();
        lastSearchedText = search; // Store the last searched text

        let sessionToken = localStorage.getItem("token");

        if (search !== "") {
            let strUrl = appConstants.paAppURL + "patient-search";

            try {
                const response = await axios.get(strUrl, {
                    params: { search: search },
                    cancelToken: new axios.CancelToken((c) => (cancel = c)), // Assign cancel function
                    headers: {
                        Authorization: sessionToken,
                        "Content-Type": "application/json",
                    },
                });

                if (search === lastSearchedText) {
                    const formattedOptions = response.data.data.map((item) => ({
                        value: item?._id,
                        label: `${item.firstName} 
            ${item.lastName} 
            (${item.patientClinicId} , 
            Age:${PF.getAgeByDob(item.dob)} Y 
            ${item.phone ? `, Phone:${item.phone}` : ''} 
            ${item.city ? `, ${item.city}` : ''} 
            ${item.height ? `, ${item.height} CM` : ''} 
            ${item.weight ? `, ${item.weight} KG` : ''})`,
                        ...item
                    }));
                    setPatients(formattedOptions)
                }
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log("Previous request canceled", error.message);
                } else {
                    console.error("API Error:", error);
                }
            }
        } else {
            setPatients([])
        }
    }, 300);

    const handlePatientDetails = (selected) => {
        setSelectedPatient(selected)
        cleanUp()
    }


    const numberToWords = (num) => {

    };

    const cleanUp = () => {
        setTotalAmount(0)
        setTotalDiscountAmount(0)
        setServices([])
        setTotalPaidAmount(0)
        setTotalRemainingAmount(0)
        setBillCategory(null)
        setBillSubCategory(null)
    }

    const handleSubmit = async () => {
        setBtnClicked(true);
        try {
            const payload = {
                patientId: selectedPatient._id,
                totalAmount: totalAmount === 0 ? "" : totalAmount.toString(),
                totalPaidAmount: totalPaidAmount === 0 ? "" : totalPaidAmount.toString(),
                totalDiscountAmount: totalDiscountAmount === 0 ? "" : totalDiscountAmount.toString(),
                totalRemainingAmount: totalRemainingAmount === 0 ? "" : totalRemainingAmount.toString(),
                installmentAmount: totalPaidAmount === 0 ? "" : totalPaidAmount.toString(),
                services: JSON.stringify(services),
            };
            let resp = null;

            if (!row) resp = await API.createBill(payload);
            else {
                payload.id = row?._id;
                resp = await API.updateBill(payload);
            }
            if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
                setIsSaveButtonClicked(true);
                handleShowSuccessMsg(row ? "updateBill" : "createBill");
                handleCloseModal();
            }

        } catch (error) {
            console.error("Error in handleSubmit:", error);
        } finally {
            setBtnClicked(false);
        }
    }

    useEffect(() => {
        if (row) {
            setBillNo(row?.billNumber)
            const patientDetail = {
                firstName: row?.patientData?.firstName,
                lastName: row?.patientData?.lastName,
                patientClinicId: row?.patientData?.patientClinicId
            }
            setSelectedPatient(patientDetail)
            setServices(row?.services)
            setPaymentMode(row?.paymentMode)
            setTotalAmount(row?.totalAmount)
            setTotalPaidAmount(row?.totalPaidAmount)
            setTotalDiscountAmount(row?.totalDiscountAmount)
            setTotalRemainingAmount(row?.totalRemainingAmount)
        }
    }, [row])


    return (
        <>

            <div style={{ marginTop: 20, textAlign: "right" }}>
                <Button
                    style={{ marginRight: 10 }}
                    disabled={row ? false : !isSaveButtonClicked}
                    onClick={(e) => setShowPreviewModal(true)}
                >
                    Preview
                </Button>
                <Button
                    bsStyle="success"
                    onClick={() => handleSubmit()}
                    disabled={!selectedPatient || services.length === 0}
                >
                    Save
                    {btnClicked && <i class="fa fa-spinner fa-spin"></i>}
                </Button>
            </div>
            {/* Patient Search */}
            {showSearchBar &&
                < FormGroup controlId="patientSelect">
                    <ControlLabel>Search Patient</ControlLabel>
                    <Select
                        id="txtSearchPatient"
                        options={patients}
                        onInputChange={(inputValue) => {
                            patientSearch(inputValue);
                        }}
                        onChange={handlePatientDetails}
                        placeholder="Search"
                        isClearable
                        isSearchable
                        value={selectedPatient}
                    />
                </FormGroup >
            }

            {/* Patient Details */}
            {
                selectedPatient ?
                    <>
                        <div style={{ border: "1px solid #ccc", padding: 10, marginBottom: 15, display: "flex", justifyContent: "space-between", }}>
                            <p><strong>Bill No:</strong> {billNo}</p>
                            <p><strong>Patient Name:</strong> {selectedPatient?.firstName} {selectedPatient?.lastName}</p>
                            <p><strong>Patient ID:</strong> {selectedPatient?.patientClinicId}</p>
                            <p><strong>Bill Date:</strong> {billDate}</p>
                        </div>



                        {/* Category, Service, Payment Mode, Amount */}
                        <Grid fluid style={{ border: "1px solid #ccc", padding: 10, marginBottom: 15 }}>
                            <Row>
                                <Col sm={12} md={6} lg={6}>
                                    <FormGroup controlId="billCategory">
                                        <ControlLabel>Category</ControlLabel>
                                        <Select
                                            options={billCategoryList}
                                            value={billCategory}
                                            onChange={(selected) => {
                                                handleBillCategory(selected)
                                            }}
                                            isClearable
                                            isSearchable
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={12} md={6} lg={6}>
                                    <FormGroup controlId="serviceName">
                                        <ControlLabel>Service</ControlLabel>
                                        <Select
                                            options={billSubCategoryList}
                                            value={billSubCategory}
                                            onChange={(selected) => {
                                                addServiceToBill(selected)
                                            }}
                                            isClearable
                                            isSearchable
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={12} md={6} lg={6}>
                                    <FormGroup controlId="paymentMode">
                                        <ControlLabel>Payment Mode</ControlLabel>
                                        <FormControl
                                            componentClass="select"
                                            value={paymentMode}
                                            onChange={(e) => setPaymentMode(e.target.value)}
                                        >
                                            <option value="cash">Cash</option>
                                            <option value="card">Card</option>
                                            <option value="upi">UPI</option>
                                        </FormControl>
                                    </FormGroup>
                                </Col>
                                <Col sm={12} md={6} lg={6}>
                                    <FormGroup controlId="amount">
                                        <ControlLabel>Amount Paid</ControlLabel>
                                        <FormControl
                                            type="number"
                                            value={totalPaidAmount || ""}
                                            placeholder="Enter amount"
                                            onChange={(e) => setTotalPaidAmount(e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Grid>
                        {/* Services Table */}
                        <BillingTable
                            items={services}
                            totalAmount={totalAmount}
                            totalPaidAmount={totalPaidAmount}
                            totalDiscountAmount={totalDiscountAmount}
                            totalRemainingAmount={totalRemainingAmount}
                            handleTotalAmount={(value) => setTotalAmount(value)}
                            handleTotalDiscount={(value) => setTotalDiscountAmount(value)}
                            handleTotalRemaining={(value) => setTotalRemainingAmount(value)}
                            onItemChange={(id, field, value) => {
                                const updatedServices = services.map(item =>
                                    item.id === id ? { ...item, [field]: value === "" ? "" : parseFloat(value) } : item
                                );
                                setServices(updatedServices)
                            }}
                            onItemDelete={(id) => {
                                const updatedServices = services.filter(item => item.id !== id);
                                setServices(updatedServices)
                            }}
                        />

                        {/* Amount in Words */}
                        <div style={{ marginTop: 15 }}>

                        </div>




                        {/* Render Preview only when modal open */}
                        {/* <Modal
                            className="pa-patient-registration"
                            show={showPreviewModal}
                            onHide={() => setShowPreviewModal(false)}
                            dialogClassName="modal-lg"
                        >
                            <Modal.Header closeButton className="Patient-headers">
                                <Modal.Title id="example-modal-sizes-title-lg">
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="Knowledge-Share card">
                                <Row>
                                    <Col md={12}>
                                        <Print
                                            patient={selectedPatient}
                                            services={services}
                                            totalAmount={totalAmount}
                                        />
                                    </Col>
                                </Row>
                            </Modal.Body>
                        </Modal> */}

                        <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} dialogClassName="modal-lg">
                            <Modal.Body>
                                <Print
                                    patient={selectedPatient}
                                    services={services}
                                    totalAmount={totalAmount}
                                    totalDiscountAmount={totalDiscountAmount}
                                    totalPaidAmount={totalPaidAmount}
                                    totalRemainingAmount={totalRemainingAmount}
                                    setShowPreviewModal={setShowPreviewModal}
                                />
                            </Modal.Body>
                        </Modal>


                    </>
                    : <strong style={{ color: "red" }}>Please Select Patient First</strong>
            }

        </>
    );
};

export default Bill;
